import {brandConfigMap} from "@/brand";
import store from "@/store";

export function setBrandConfig() {
    const domain = window.origin;
    console.log(`Domain: ${domain}`);
    const brandConfig = brandConfigMap.get(domain) ? brandConfigMap.get(domain) : brandConfigMap.get('default');
    console.log(`Brand Config Set: ${JSON.stringify(brandConfig)}`);
    store.commit('setBrandConfig', brandConfig);
}
